module.exports = __webpack_public_path__ + "img/image3.0ae3284b.jpeg";